import styled from '@emotion/styled';

interface InputProps {}

const StyledTextArea = styled.textarea<InputProps>`
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--border1);
  padding: 10px 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--prim1);
  resize: none;

  &::placeholder {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.01em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #b2b0b0;
  }

  &:focus {
    outline: none;
    border: 1px solid var(--prim4);
  }
`;

export default StyledTextArea;
